import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
`;

export const Children = styled.main`
  min-height: 100vh;
  background: #fff;
  width: 100%;
`;
